export const gateway = {
  IPAddress: 'disposuite-dev-api.feller.ch',
  port: '',
  protocol: 'https',
};

export const authZeroConfig = {
  domain: 'id-staging.feller.ch',
  client_id: 'Wc6vSDeO4Axa7aaKwZM3vFZqyh9j0xRn',
  audience: 'https://disposuite-preprod.feller.ch'
};

// LOSI-51 Start
export const userProfileUrl = {
  domain: 'https://feller-account-staging.netlify.app'
};
// LOSI-51 End

export const productSelector = {
  productSelectorListing: gateway.protocol + '://' + gateway.IPAddress + '/api/v1/ProductSelector',
  productSelector: gateway.protocol + '://' + gateway.IPAddress + '/api/v1/ProductSelector/{psId}',
  productImage: 'https://kqbdyzc7mdyoue2scorzocyzyi0ktdrw.lambda-url.eu-west-3.on.aws/img_{reference}_jpg',
  productImageBackup: gateway.protocol + '://' + gateway.IPAddress + '/api/v1/productCatalog/product/image/?reference={reference}'
};

export const environment = {
  tag: 'Development',
  cookieDomain: '.feller.ch',
  cookieNameAnalytics: 'google-analytics-opt-out',
  schemaVersion: 1,
  userFeedback: 'u6LVHtvZBfiHiIWdoCa8j25rpEeanGql',
  transferToElbridge2Link: 'https://interface.elbridge2.itek.de/',
  version: 'api/v1',
  production: true,
  apiEndpoint: gateway.protocol + '://' + gateway.IPAddress,
  ProductSelector: {
    productSelectorListing: productSelector.productSelectorListing,
    productSelector: productSelector.productSelector,
    productImage: productSelector.productImage,
    productImageBackup: productSelector.productImageBackup
  },
  domain: 'https://disposuite-dev.feller.ch/#/home/shared',
  googleAnalyticsCode: 'UA-177090861-2',
  googleTrackingCode: 'GTM-T47SQL4T',
  dataDomainScript: '4f1be85c-ebe7-4af0-a19e-a42e73fe9337-test',
  languageSettings: {
    availableLanguages: [
      'de',
      'fr',
      'it',
      'en',
    ],
    defaultLanguage: 'de'
  },
  // Preview gate (soft gate), see src/modules/preview-gate/README.md
  previewGate: {
    enabled: true,
    salt: 'disposuite-preview-gate',
    credentialsHash: 'c9966655a1245e962a5cc7f78630d87b3df99468a64698c650c79bdf692b6a86',
    storageKey: 'disposuite.preview-gate'
  },
};
